import React from "react";
import { useSelector } from "react-redux";
import { actions as refillsActions } from "reducers/refills";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import { ResponsiveHeader } from "pages/_components/header";
import CustomText from "pages/_components/CustomText/CustomText";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import * as i18n from "util/i18n";
import RefillsSummaryBody from "./refillsSummaryBody";

const RefillsConfirmationPage = () => {
    const { formData, refillsTicket } = useSelector((state) => state.refills);
    useConfirmTransaction(formData, refillsTicket, `payments/refills`);

    return (
        <>
            <Notification scopeToShow="refillsConfirmationPage" />
            <ResponsiveHeader id="refills.title" showLabel />
            <MainContainer>
                <div className="container endorse-echeq">
                    <CustomText text="Controlá los datos" textType="TEXT" className="custom-text custom-data-title" />
                    <RefillsSummaryBody formData={formData} />
                    <GeneralCredentialForm
                        transactionData={formData}
                        action={refillsActions.payService}
                        customIndications={i18n.get("rapipago.message.remenber")}
                        idActivity="rapipago.operation.confirm"
                        isToken
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default RefillsConfirmationPage;
